import type { ChemistryControllerHost } from '@adornis/chemistry/controllers/chemistry-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html } from 'lit';

export const onlineStatusDot = (host: ChemistryControllerHost) => html`
  <div
    ${css({
      background: host.colors.tone.success,
      height: '8px',
      width: '8px',
      borderRadius: '50%',
      position: 'absolute',
      left: '-5px',
      bottom: '-5px',
      border: `2px solid ${host.colors.neutral.shade(50)}`,
    })}
  ></div>
`;
